import React from "react";
import { Drawer } from "vaul";

/* Edge sheet that slides in over the content, mobile-app style. Same token
   styling as BottomSheet.

   `side`:
   - "left"  — navigation (the original use: sidebars below `lg`)
   - "right" — an inspector for the row you just clicked, on any breakpoint */
export default function SideSheet({ open, onOpenChange, side = "left", width = 300, title, children }: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  side?: "left" | "right";
  width?: number | string;
  title?: string;
  children?: React.ReactNode;
}) {
  const right = side === "right";
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} direction={side}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-50 bg-black/35 backdrop-blur-[1px]" />
        <Drawer.Content
          className={`fixed top-0 bottom-0 z-50 max-w-[92vw] flex outline-none ${
            right
              ? "right-0 bg-[var(--canvas)] shadow-[-8px_0_40px_rgba(0,0,0,0.18)]"
              : "left-0 bg-[var(--surface-sunk)] shadow-[8px_0_40px_rgba(0,0,0,0.18)]"
          }`}
          style={{ width }}
        >
          <Drawer.Title className="sr-only">{title || (right ? "Details" : "Navigation")}</Drawer.Title>
          {/* [&>*] — sidebar components size themselves h-full; give them a full-height parent */}
          <div className="flex-1 min-w-0 min-h-0 pt-safe pb-safe [&>*]:h-full [&>*]:min-h-0">{children}</div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
